import { global_hooks } from './globals';

import './main.scss';
import 'assets/icomoon/style.css'; // icomoon

import 'elementor/custom_widgets/init';

import 'components/admin_bar/init';
import 'components/retina/init';
import 'components/header_sticky/init';
import 'components/footer_sticky_cta/init';
import 'components/nav_menu/init';
//import 'components/mega_menu/init';
import 'components/slide_menu/init';
import 'components/carousel/init';
import 'components/carousel_mobile/init';
// import 'components/forms/init';
// import 'components/form_steps/init';
import 'components/scroll_to_top/init';
import 'components/toggle_height/init';

//import 'modules/search/search_popup/init';

// import 'components/toggle_parent/init';
// import 'components/cookie_consent/init';

document.addEventListener('DOMContentLoaded', init);

function init() {
	global_hooks.do('before_init');

	if (ff.is_elementor_edit) return;

	global_hooks.do('init');

	on_mobile();

	window.addEventListener('resize', on_mobile);


	global_hooks.do('after_init');
}


function on_mobile() {
	if (window.innerWidth > 768) return;

	close_footer_dropdowns();
	closed_accordion_mobile();
	accordion_anchor_mobile();

	setTimeout(() => {
		close_footer_dropdowns();
	}, 300);
}

function close_footer_dropdowns() {
	document
		.querySelectorAll('.elementor-location-footer .ff_toggle_height_trigger.open')
		.forEach(dropdown => {
			dropdown.click();
		});
}

function accordion_anchor_mobile() {
	if (window.innerWidth >= 768) return;

	document.querySelectorAll('.e-n-accordion-item-title').forEach(title => {
		if (title._mob_anchor) return;
		title._mob_anchor = true;

		title.addEventListener('click', () => {
			const item = title.closest('.e-n-accordion-item');
			if (!item || item.hasAttribute('open')) return;

			setTimeout(() => {
				const stickyHeaderHeight = 220;
				const top = title.getBoundingClientRect().top + window.scrollY - stickyHeaderHeight;
				window.scrollTo({ top, behavior: 'smooth' });
			}, 350);
		});
	});
}

function closed_accordion_mobile() {
	const is_mobile = window.innerWidth < 768;
	if (!is_mobile) return;

	const delay = 100;

	setTimeout(() => {
		jQuery('.e-n-accordion-item').removeAttr('open');
	}, delay);
}